












import { Component, Vue } from "vue-property-decorator";
import Menu from "./views/Menu.vue";
import Foot from "./views/Footer.vue";
import BackTop from "./components/BackToTop.vue";
import Nav from "./views/Nav.vue";

@Component({
  components: {
    Menu,
    Foot,
    BackTop,
    Nav
  }
})
export default class App extends Vue {
  private mounted() {
    this.$store.commit("changeLanguage");
  }
}
